// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconLogoTwitter = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M13.857 10.469L21.142 2h-1.726L13.09 9.353 8.037 2H2.21l7.64 11.12L2.21 22h1.726l6.68-7.765L15.954 22h5.827zm-2.365 2.748l-.774-1.107-6.16-8.81H7.21l4.971 7.11.774 1.107 6.461 9.242h-2.651z" />
  );
export default SvgIconLogoTwitter;
